import React, { useState, useEffect, useContext } from "react";
import CommonListHeader from 'components/layout/list/header'
import CommonNavigatorHeader from "components/layout/list/navigation";
import CommonTableContainer from 'components/layout/list/table'
import {useOrgListQuery} from "services/org";
import { v4 as uuidv4 } from 'uuid'
import { useParams } from "react-router-dom";

const OrgMain = () => {
    
    let { filter } = useParams();
    const [page, setPage] = useState(0)

    const tableTitle = [
        {md: 5, value: 'Organization Name' },
        {md: 2, value: 'E-Mail' },
        {md: 2, value: 'Phone' },
        {md: 5, value: 'Location' },
        {md: 5, value: 'Since', sort: 'createDate'  },
        {md: 1, value: 'Status' },
    ]

    const [criteria, setCriteria] = useState({
        filter: filter,
        page: 0,
        requestId: uuidv4(),
        sort: 'name.keyword',
        order: 'desc',
        searchKeyword: '',
    });

    const {activeOrgList, activeCount, activeStatus, activeLoading, fetching} = useOrgListQuery({criteria: criteria}, 
        {
          selectFromResult: ({ data, status, isLoading, isFetching }) => ({
            activeOrgList: data?.hits?.hits?.map(d=>d._source) || [],
            activeCount: data?.hits?.total?.value || 0,
            activeStatus: status,
            activeLoading: isLoading,
            fetching: isFetching
          })
        }
    );

    return (
        <React.Fragment>
            <CommonListHeader value = {{title: "Organization Management", description: "List of all Organization", link: '/orgs/create', buttonName: "Create New Org"}} />
            <CommonNavigatorHeader value = {{
                total: activeCount, 
                search: {
                    label: '', 
                    placeHolder: ''
                },
                setPage: setPage,
                page: page,
                setCriteria: setCriteria,
                criteria: criteria
            }} />
            <CommonTableContainer 
                value = {{
                    tableTitle: tableTitle,
                    sort: 'Org Id',
                    loadRow: [0, 1, 2, 3, 4, 5, 6],
                    loadColumn: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                    activeList: activeOrgList,
                    type: 'org',
                    fulfilled: activeStatus
                }}
            />
        </React.Fragment>
    );
}

export default OrgMain;